import React from 'react';
import { OpenArtWeaverButton, OpenPdfButton } from './ArtWeaverButtons';
import { RESOURCE_CARDS } from './CourseChapterPanel';

// The lesson's worksheet: its first PDF. Open PDF and the drawing page's worksheet pane show it.
export const worksheetOf = (lesson) => lesson.items.find((item) => item.type === 'pdf') || null;

/**
 * The numbered lesson rows: picture, title (and coins), then Open PDF and Open ArtWeaver, and a
 * button for each of the lesson's other items (video, quiz, game ...). Open ArtWeaver opens that
 * lesson's drawing page (`onOpenActivity(id)`); the other buttons open their item
 * (`onOpenItem(item, lesson)`, CourseContentView).
 */
export default function ArtActivityList({ lessons, onOpenActivity, onOpenItem }) {
  return (
    <ol className="flex flex-col gap-3">
      {lessons.map((lesson, index) => {
        const worksheet = worksheetOf(lesson);
        // Two items of the same type are told apart by their own titles.
        const typeCounts = lesson.items.reduce((counts, item) => ({ ...counts, [item.type]: (counts[item.type] || 0) + 1 }), {});
        const others = lesson.items.filter((item) => item !== worksheet);
        return (
          <li
            key={lesson.id}
            className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white px-4 py-3 shadow-sm"
          >
            <span className="w-5 shrink-0 text-center text-base font-extrabold text-slate-700">{index + 1}</span>
            <span
              className="flex h-[88px] w-[88px] shrink-0 items-center justify-center rounded-xl bg-sky-50 text-5xl"
              aria-hidden="true"
            >
              🎨
            </span>
            <div className="min-w-0 flex-1">
              <div className="mb-2 flex flex-wrap items-center gap-2">
                <h3 className="text-lg font-extrabold leading-tight text-slate-900">{lesson.title}</h3>
                {lesson.coins > 0 && (
                  <span className="rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-extrabold text-amber-700">
                    🪙 {lesson.coins}
                  </span>
                )}
              </div>
              <div className="flex flex-wrap gap-3">
                <OpenPdfButton title={lesson.title} item={worksheet} onOpen={(item) => onOpenItem(item, lesson)} className="w-36" />
                <OpenArtWeaverButton
                  title={lesson.title}
                  onClick={() => onOpenActivity(lesson.id)}
                  className="w-full min-w-[11rem] sm:w-auto sm:flex-1 sm:max-w-[16rem]"
                />
                {others.map((item) => {
                  const resource = RESOURCE_CARDS[item.type] || RESOURCE_CARDS.text;
                  const name = typeCounts[item.type] > 1 ? item.title : resource.label;
                  return (
                    <button
                      key={item.id}
                      type="button"
                      onClick={() => onOpenItem(item, lesson)}
                      aria-label={`${resource.action}: ${lesson.title} ${name}`}
                      className="flex items-center justify-center gap-2 rounded-xl border-2 border-gray-200 bg-white px-4 py-2.5 text-sm font-extrabold text-slate-700 shadow-sm transition-colors hover:bg-gray-50"
                    >
                      <span aria-hidden="true">{resource.icon}</span>
                      {resource.action}
                    </button>
                  );
                })}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
